import type { StatusOption } from '@/types/global.types';

/** Where the Payroll page lives; batch pages link back to it. */
export const PAYROLL_PATH = '/admin/employee/payroll';

/** First breadcrumb of every payroll page. */
export const DASHBOARD_CRUMB = {
  title: 'Dashboard',
  path: '/admin/employee/dashboard',
};

export const EMPLOYEE_TYPE_OPTIONS = [
  { label: 'Full Time', value: 'full-time' },
  { label: 'Part Time', value: 'part-time' },
  { label: 'Contract', value: 'contract' },
];

export const ACTIVE_STATUS_OPTIONS = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const ACTIVE_STATUS_CONFIG: StatusOption[] = [
  { label: 'Active', value: 'active', className: 'status status-success' },
  { label: 'Inactive', value: 'inactive', className: 'status status-error' },
];

/** Payment state of a payroll batch or a bank-list row. */
export const PAYMENT_STATUS_CONFIG: StatusOption[] = [
  { label: 'Failed', value: 'FAILED', className: 'status status-error' },
  { label: 'Paid', value: 'PAID', className: 'status status-success' },
  { label: 'Unpaid', value: 'UNPAID', className: 'status status-yellow' },
];

/** Who a bonus policy is for. Old policies carry none and show "n/a". */
export const BONUS_PAY_BASIS_CONFIG: StatusOption[] = [
  { label: 'All', value: 'ALL', className: 'status status-fuchsia' },
  { label: 'Monthly', value: 'MONTHLY', className: 'status status-slate' },
  { label: 'Daily', value: 'DAILY', className: 'status status-sky' },
];

/** Monthly or daily population. Missing on old batches, which were monthly. */
export const PAY_BASIS_CONFIG: StatusOption[] = [
  { label: 'Monthly', value: 'MONTHLY', className: 'status status-slate' },
  { label: 'Daily', value: 'DAILY', className: 'status status-sky' },
];
